import React from "react";

export const BreakdownsDeactivatedMessage = () => {
  return (
    <div className="flex items-center text-xxs text-mars">
      <i className="fa-regular fa-exclamation-circle mr-1 text-xs" />
      Breakdowns impacting this tile have been deactivated or deleted
    </div>
  );
};
